import { createFileRoute } from '@tanstack/react-router';
import { AccountListPage } from '@/pages/admin/accounts/AccountListPage';

export const Route = createFileRoute('/admin/accounts/')({
  component: AccountListPage
});
